import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouteLink} from 'react-router-dom'
import {Box, Image, Link, Heading} from '@salesforce/retail-react-app/app/components/shared/ui'
import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'
import {blogRoute} from '../../utills/url'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const PopularPosts = ({popularPost}) => {
    const {isFeatureMediaVideo, featuredMedia, id, publishDate, name, title} = popularPost
    return (
        <>
            <Box
                marginBottom={pxToRem(20)}
                marginTop={0}
                padding={`0 ${pxToRem(5)} ${pxToRem(10)}`}
                borderBottom={'1px solid'}
                borderColor={'cav_pdp_light_gray'}
                _last={{borderBottom: 'none'}}
            >
                <Box>
                    {featuredMedia ? (
                        isFeatureMediaVideo ? (
                            <Box
                                sx={{
                                    position: 'relative',
                                    paddingBottom: '56.25%',
                                    height: 0,
                                    overflow: 'hidden'
                                }}
                            >
                                <iframe
                                    src={featuredMedia}
                                    title={title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    referrerPolicy="strict-origin-when-cross-origin"
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%'
                                    }}
                                ></iframe>
                            </Box>
                        ) : (
                            <Link
                                to={blogRoute(`${id}.html`)}
                                as={RouteLink}
                                title={title}
                                _hover={{textDecoration: 'none', color: 'cav_hover_brightred'}}
                            >
                                {featuredMedia ? (
                                    <Image src={featuredMedia} alt={name} width={'100%'} />
                                ) : (
                                    <Image
                                        src={getAssetUrl('static/img/blog-list/blplaceholder.png')}
                                        width={'100%'}
                                    />
                                )}
                            </Link>
                        )
                    ) : null}

                    <Box
                        as="p"
                        textTransform={'none'}
                        fontSize={pxToRem(12)}
                        fontFamily={fonts.primary}
                        lineHeight={pxToRem(18)}
                        letterSpacing={pxToRem(1)}
                        color={'cav_light_black'}
                        textAlign={'center'}
                        margin={`${pxToRem(5)} 0`}
                        fontWeight={400}
                    >
                        {publishDate}
                    </Box>
                    <Heading
                        as="h5"
                        textAlign={'center'}
                        textTransform={'none'}
                        fontSize={pxToRem(14)}
                        lineHeight={pxToRem(20)}
                        letterSpacing={pxToRem(1)}
                    >
                        <Link
                            key={id}
                            to={blogRoute(`${id}.html`)}
                            as={RouteLink}
                            title={title}
                            fontSize={pxToRem(14)}
                            lineHeight={pxToRem(20)}
                            letterSpacing={pxToRem(1)}
                            textAlign={'center'}
                            color={'cav_light_black'}
                            fontFamily={fonts.primary}
                            fontWeight={700}
                            _hover={{textDecoration: 'none', color: 'cav_hover_brightred'}}
                        >
                            <Box dangerouslySetInnerHTML={{__html: name}}></Box>
                        </Link>
                    </Heading>
                </Box>
            </Box>
        </>
    )
}

PopularPosts.propTypes = {
    popularPost: PropTypes.object
}
export default PopularPosts
